// react
import { useState } from 'react';

// router
import { useParams } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Act } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormUploadDocs } from '../../forms/FormUploadDocs/FormUploadDocs';

// props
export interface DialogUploadDocsActProps {
	act: Act;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogUploadDocsAct = ({
	act,
	isOpen,
	onClose,
	onSuccess,
}: DialogUploadDocsActProps) => {
	// hooks
	const { idAct } = useParams();
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('uploadDocuments'),
					form: 'form-upload-docs-act',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			alignItems="center"
			hasClose={true}
			IconCircleProps={{
				type: 'document',
			}}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={{ children: !idAct ? act.name : undefined }}
			title={{
				children: t('uploadDocuments'),
			}}>
			<FormUploadDocs
				actId={act.id}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
